import { GameplayTier } from '#src/__generated__/globalTypes.ts';
import { Stars } from '#src/components/card/StarRank/Stars/index.tsx';
import { GAMEPLAY_TIER_LABELS } from '#src/lib/gameplayTiers.ts';
import type { unitMapping } from '#src/lib/style.ts';

const convertTierToNumberOfStars = (gameplayTier: GameplayTier) => {
  return {
    [GameplayTier.GOAT]: 5,
    [GameplayTier.STAR]: 4,
    [GameplayTier.IMPACT]: 3,
    [GameplayTier.ROSTER]: 2,
    [GameplayTier.DNP]: 1,
  }[gameplayTier];
};

type GameplayTierStarsProps = {
  gameplayTier: GameplayTier;
  size?: keyof typeof unitMapping;
};

export const GameplayTierStars = ({
  gameplayTier,
  size = 1,
}: GameplayTierStarsProps) => {
  const nbStars = convertTierToNumberOfStars(gameplayTier);
  const sparkles = GameplayTier.GOAT === gameplayTier;
  const accessibilityLabel = GAMEPLAY_TIER_LABELS[gameplayTier];

  return (
    <Stars count={nbStars} size={size} sparkles={sparkles}>
      <span className="sr-only">{accessibilityLabel}</span>
    </Stars>
  );
};
